/**
 * PDF export — style facture (tableau), pied de page mentions légales.
 * Sections : size-calculator, imposition V3 isolated.
 * Requires jspdf.umd.min.js (window.jspdf.jsPDF).
 */
(function () {
  function calcT(key, fallback, vars) {
    var dict = window.__calculatorI18n || {};
    var text = dict[key] != null ? String(dict[key]) : String(fallback == null ? key : fallback);
    if (vars) Object.keys(vars).forEach(function (name) { text = text.split('{' + name + '}').join(String(vars[name])); });
    return text;
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function normText(el) {
    return el ? String(el.textContent || "").replace(/\s+/g, " ").trim() : "";
  }

  function parseQtyFromChip(text) {
    var t = String(text || "").trim();
    var m = t.match(/[×x]\s*(\d+)/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function parseQty(el) {
    if (!el) return null;
    var d = el.getAttribute("data-qty");
    if (d != null && d !== "") {
      var n = parseInt(d, 10);
      if (Number.isFinite(n)) return n;
    }
    return parseQtyFromChip(normText(el));
  }

  function parseEuroNumber(txt) {
    return parseSignedEuroNumber(txt);
  }

  function parseSignedEuroNumber(txt) {
    var t = String(txt || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s/g, "")
      .replace(",", ".");
    var m = t.match(/(-?[\d.]+)/);
    if (!m) return null;
    var v = parseFloat(m[1]);
    return Number.isFinite(v) ? v : null;
  }

  function formatMoneyEUR(n) {
    if (n == null || !Number.isFinite(n)) return "—";
    var sign = n < 0 ? "-" : "";
    return sign + Math.abs(n).toFixed(2).replace(".", ",") + " €";
  }

  function parseTotalPrice(el) {
    if (!el) return null;
    var p = el.getAttribute("data-price");
    if (p != null && p !== "") {
      var f = parseFloat(p);
      if (Number.isFinite(f) && f !== Infinity && f > 0) return f;
    }
    return parseEuroNumber(normText(el));
  }

  function selectedProductLabel(section) {
    var sel = section.querySelector("[is-product-types]");
    if (!sel || sel.selectedIndex < 0) return "—";
    var opt = sel.options[sel.selectedIndex];
    return opt ? normText(opt) : "—";
  }

  function collectInvoiceRowsSizeCalculator(section) {
    var delaySel = section.querySelector("[is-delay-option-results]");
    var delayLabel = "";
    if (delaySel && delaySel.selectedIndex >= 0) {
      var opt = delaySel.options[delaySel.selectedIndex];
      delayLabel = opt ? normText(opt) : "";
    }
    var list = section.querySelector("[is-calculated-result-card-list]");
    if (!list) return { delayLabel: delayLabel, rows: [], rowsEasyOrder: [] };

    var cards = [].slice.call(list.querySelectorAll("[is-calculated-result-card]"));
    var productLabel = selectedProductLabel(section);
    var rows = [];
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.classList.contains("rejected")) continue;

      var format = normText(card.querySelector("[is-format]"));
      var sizeTxt = normText(card.querySelector("[is-size]"));
      var qtyEl = card.querySelector("[is-sheets-qty]");
      var totalEl = card.querySelector("[is-total-price]");
      var unitEl = card.querySelector("[is-price-per-unit]");

      var totalNum = parseTotalPrice(totalEl);
      if (totalNum == null || totalNum <= 0) continue;

      var isPlaceholder =
        /^0\s*[x×]\s*0\b/i.test(sizeTxt) && (!format || format === "A0") && totalNum <= 0;
      if (isPlaceholder) continue;

      var qty = parseQty(qtyEl);
      var qtyStr = qty != null && Number.isFinite(qty) ? String(qty) : normText(qtyEl) || "—";
      var unitNum = parseEuroNumber(normText(unitEl));

      rows.push({
        ref: format || "—",
        produit: productLabel,
        format: format || "—",
        delay: delayLabel || "—",
        unitNum: unitNum,
        unitDisplay: unitNum != null ? formatMoneyEUR(unitNum) : normText(unitEl) || "—",
        qty: qtyStr,
        totalNum: totalNum,
        totalDisplay: formatMoneyEUR(totalNum)
      });
    }
    return { delayLabel: delayLabel, rows: rows, rowsEasyOrder: [] };
  }

  function collectInvoiceRowsV3Isolated(section) {
    var delaySel = section.querySelector("[is-delay-option-results]");
    var delayLabel = "";
    if (delaySel && delaySel.selectedIndex >= 0) {
      var opt = delaySel.options[delaySel.selectedIndex];
      delayLabel = opt ? normText(opt) : "";
    }
    var productLabel = selectedProductLabel(section);
    var rowsPlanche = [];
    var rowsEasyOrder = [];

    var list = section.querySelector("[is-calculated-result-card-list]");
    var card = list && list.querySelector("[is-calculated-result-card]");
    var planchePanel =
      card &&
      card.querySelector(".scenario-quote-panel:not(.scenario-quote-panel--easy-order)");
    var easyPanel = card && card.querySelector(".scenario-quote-panel--easy-order");

    var itemsPlanche = planchePanel
      ? [].slice.call(planchePanel.querySelectorAll(".v3i-quote-item"))
      : [];
    var itemsEasy = easyPanel ? [].slice.call(easyPanel.querySelectorAll(".v3i-quote-item")) : [];

    if (!itemsPlanche.length && !itemsEasy.length) {
      var items = [].slice.call(section.querySelectorAll(".v3i-quote-item"));
      for (var f = 0; f < items.length; f++) {
        var el = items[f];
        if (el.closest(".scenario-quote-panel--easy-order")) {
          itemsEasy.push(el);
        } else if (el.closest(".scenario-quote-panel")) {
          itemsPlanche.push(el);
        }
      }
    }

    for (var i = 0; i < itemsPlanche.length; i++) {
      var item = itemsPlanche[i];
      if (item.classList.contains("v3i-quote-item--easy-order")) continue;
      var planche = normText(item.querySelector(".v3i-quote-title"));
      var format = normText(item.querySelector(".v3i-chip--format"));
      var qtyChip = normText(item.querySelector(".v3i-chip--qty"));
      var linePrice = normText(item.querySelector(".v3i-quote-line-price"));
      var unitHint = normText(item.querySelector(".v3i-quote-unit-hint"));

      if (item.classList.contains("v3i-quote-item--discount")) {
        var discountTotal = parseSignedEuroNumber(linePrice);
        if (discountTotal == null || discountTotal === 0) continue;
        rowsPlanche.push({
          ref: planche || calcT('volume_discount', 'Remise volume'),
          produit: "—",
          format: "—",
          delay: "—",
          unitNum: null,
          unitDisplay: unitHint || "—",
          qty: "—",
          totalNum: discountTotal,
          totalDisplay: formatMoneyEUR(discountTotal)
        });
        continue;
      }

      if (item.classList.contains("v3i-quote-item--gpo-addon")) {
        var addonTotal = parseSignedEuroNumber(linePrice);
        if (addonTotal == null || addonTotal <= 0) continue;
        var addonRef = planche || calcT('personalization_addons', 'Supplément');
        var addonProduit = unitHint || "—";
        if (addonProduit !== "—" && addonRef.indexOf(addonProduit) >= 0) {
          addonProduit = "—";
        }
        rowsPlanche.push({
          ref: addonRef,
          produit: addonProduit,
          format: "—",
          delay: delayLabel || "—",
          unitNum: null,
          unitDisplay: "—",
          qty: "—",
          totalNum: addonTotal,
          totalDisplay: formatMoneyEUR(addonTotal)
        });
        continue;
      }

      var dataBaseTotal = item.getAttribute("data-base-total");
      var dataUnitBase = item.getAttribute("data-unit-base");
      var totalNum =
        dataBaseTotal != null && dataBaseTotal !== ""
          ? parseFloat(dataBaseTotal)
          : parseSignedEuroNumber(linePrice);
      if (totalNum == null || totalNum <= 0) continue;

      var qtyNum = parseQtyFromChip(qtyChip);
      var qtyStr = qtyNum != null && Number.isFinite(qtyNum) ? String(qtyNum) : qtyChip || "—";
      var unitNum =
        dataUnitBase != null && dataUnitBase !== ""
          ? parseFloat(dataUnitBase)
          : parseSignedEuroNumber(unitHint);

      rowsPlanche.push({
        ref: planche || "—",
        produit: productLabel,
        format: format || "—",
        delay: delayLabel || "—",
        unitNum: unitNum,
        unitDisplay: unitNum != null ? formatMoneyEUR(unitNum) : unitHint || "—",
        qty: qtyStr,
        totalNum: totalNum,
        totalDisplay: formatMoneyEUR(totalNum)
      });
    }

    for (var j = 0; j < itemsEasy.length; j++) {
      var itemEo = itemsEasy[j];
      var plancheEo = normText(itemEo.querySelector(".v3i-quote-title"));
      var linePriceEo = normText(itemEo.querySelector(".v3i-quote-line-price"));
      var totalNumEo = parseEuroNumber(linePriceEo);
      if (totalNumEo == null || totalNumEo <= 0) continue;
      var qtyAttrEo = itemEo.getAttribute("data-easy-order-qty");
      var qtyStrEo = qtyAttrEo != null && qtyAttrEo !== "" ? qtyAttrEo : "—";
      rowsEasyOrder.push({
        ref: plancheEo || "—",
        produit: productLabel + ' (Easy Order)',
        format: 'Easy Order',
        delay: delayLabel || "—",
        unitNum: null,
        unitDisplay: "—",
        qty: qtyStrEo,
        totalNum: totalNumEo,
        totalDisplay: formatMoneyEUR(totalNumEo)
      });
    }

    return { delayLabel: delayLabel, rows: rowsPlanche, rowsEasyOrder: rowsEasyOrder };
  }

  function collectInvoiceRows(section) {
    var mode = section.getAttribute("data-imposition-quote-pdf") || "";
    if (mode === "v3-isolated") return collectInvoiceRowsV3Isolated(section);
    return collectInvoiceRowsSizeCalculator(section);
  }

  function loadImageDataUrl(url, cb) {
    if (!url) {
      cb(null);
      return;
    }
    fetch(url, { mode: "cors", credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.blob();
      })
      .then(function (blob) {
        return new Promise(function (resolve, reject) {
          var fr = new FileReader();
          fr.onload = function () {
            resolve(fr.result);
          };
          fr.onerror = reject;
          fr.readAsDataURL(blob);
        });
      })
      .then(function (dataUrl) {
        cb(dataUrl);
      })
      .catch(function () {
        cb(null);
      });
  }

  function imageFormatFromDataUrl(dataUrl) {
    if (!dataUrl || typeof dataUrl !== "string") return "PNG";
    if (dataUrl.indexOf("image/jpeg") === 5 || dataUrl.indexOf("image/jpg") === 5) return "JPEG";
    return "PNG";
  }

  function toast(msg) {
    if (typeof Toastify === "function") {
      Toastify({
        text: msg,
        duration: 5000,
        close: true,
        className: "toast-message",
        position: "left"
      }).showToast();
    } else {
      window.alert(msg);
    }
  }

  function drawFooterOnAllPages(doc, pageW, pageH, margin, contentW) {
    var n = doc.getNumberOfPages();
    var shipping = calcT('pdf_shipping', "Tarifs d'expédition à partir de 6€ HT");
    var legal =
      calcT('pdf_legal', "Les tarifs sont susceptibles d'évoluer ; seuls les tarifs du site font foi.");
    var footerH = 20;
    var y0 = pageH - margin - footerH;

    for (var p = 1; p <= n; p++) {
      doc.setPage(p);
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.3);
      doc.line(margin, y0 - 2, pageW - margin, y0 - 2);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8.5);
      doc.setTextColor(55, 55, 55);
      doc.text(shipping, margin, y0 + 2);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(90, 90, 90);
      var lines = doc.splitTextToSize(legal, contentW);
      doc.text(lines, margin, y0 + 7);
      doc.setTextColor(0, 0, 0);
    }
  }

  function drawInvoiceTable(doc, margin, contentW, startY, rows, options) {
    options = options || {};
    if (!rows || !rows.length) return startY;

    var pageH = doc.internal.pageSize.getHeight();
    var pageW = doc.internal.pageSize.getWidth();
    var footerReserve = 34;
    var maxY = pageH - margin - footerReserve;

    var colW = {
      ref: contentW * 0.16,
      produit: contentW * 0.22,
      format: contentW * 0.1,
      delay: contentW * 0.18,
      unit: contentW * 0.14,
      qty: contentW * 0.08,
      total: contentW * 0.12
    };
    var xRef = margin;
    var xProd = xRef + colW.ref;
    var xFmt = xProd + colW.produit;
    var xDel = xFmt + colW.format;
    var xUnit = xDel + colW.delay;
    var xQty = xUnit + colW.unit;
    var xTot = xQty + colW.qty;

    var rowH = 7;
    var headerH = 8;
    var y = startY;

    function ensureTableSpace(h) {
      if (y + h > maxY) {
        doc.addPage();
        y = margin;
        maxY = pageH - margin - footerReserve;
      }
    }

    if (options.sectionTitle) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(45, 45, 45);
      ensureTableSpace(8);
      doc.text(String(options.sectionTitle), margin, y + 5);
      y += 8;
      doc.setTextColor(0, 0, 0);
    }

    function cellText(txt, x, cx, yBase, align) {
      doc.setFontSize(8.5);
      var maxW = cx - 1.5;
      var lines = doc.splitTextToSize(String(txt || "—"), maxW);
      var lineCount = Math.min(lines.length, 2);
      for (var li = 0; li < lineCount; li++) {
        if (align === "right") {
          var tw = doc.getTextWidth(lines[li]);
          doc.text(lines[li], x + cx - 1.5 - tw, yBase + 4 + li * 3.2);
        } else {
          doc.text(lines[li], x + 1.5, yBase + 4 + li * 3.2);
        }
      }
    }

    function drawRow(bg, isHeader) {
      var h = isHeader ? headerH : rowH;
      ensureTableSpace(h);
      doc.setDrawColor(60, 60, 60);
      doc.setLineWidth(0.15);
      if (bg) {
        doc.setFillColor(242, 242, 242);
        doc.rect(margin, y, contentW, h, "FD");
      } else {
        doc.rect(margin, y, contentW, h, "S");
      }
      doc.line(xProd, y, xProd, y + h);
      doc.line(xFmt, y, xFmt, y + h);
      doc.line(xDel, y, xDel, y + h);
      doc.line(xUnit, y, xUnit, y + h);
      doc.line(xQty, y, xQty, y + h);
      doc.line(xTot, y, xTot, y + h);
      return h;
    }

    doc.setFont("helvetica", "bold");
    var hh = drawRow(true, true);
    cellText(calcT('pdf_reference', 'Référence'), xRef, colW.ref, y, "left");
    cellText(calcT('product', 'Produit'), xProd, colW.produit, y, "left");
    cellText(calcT('format', 'Format'), xFmt, colW.format, y, "left");
    cellText(calcT('production_delay', 'Délai'), xDel, colW.delay, y, "left");
    cellText(calcT('pdf_unit_price', 'Prix unit. HT'), xUnit, colW.unit, y, "right");
    cellText(calcT('pdf_qty', 'Qté'), xQty, colW.qty, y, "right");
    cellText(calcT('pdf_total', 'Total HT'), xTot, colW.total, y, "right");
    y += hh;

    function rowBlockHeight(row) {
      doc.setFontSize(8.5);
      var lineCounts = [
        doc.splitTextToSize(String(row.ref || "—"), colW.ref - 1.5).length,
        doc.splitTextToSize(String(row.produit || "—"), colW.produit - 1.5).length,
        doc.splitTextToSize(String(row.delay || "—"), colW.delay - 1.5).length
      ];
      var lines = Math.min(Math.max.apply(null, lineCounts.concat([1])), 3);
      return Math.max(rowH, 4 + lines * 3.2 + 1);
    }

    doc.setFont("helvetica", "normal");
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      var currentRowH = rowBlockHeight(row);
      ensureTableSpace(currentRowH);
      doc.setDrawColor(60, 60, 60);
      doc.setLineWidth(0.15);
      doc.rect(margin, y, contentW, currentRowH, "S");
      doc.line(xProd, y, xProd, y + currentRowH);
      doc.line(xFmt, y, xFmt, y + currentRowH);
      doc.line(xDel, y, xDel, y + currentRowH);
      doc.line(xUnit, y, xUnit, y + currentRowH);
      doc.line(xQty, y, xQty, y + currentRowH);
      doc.line(xTot, y, xTot, y + currentRowH);
      cellText(row.ref, xRef, colW.ref, y, "left");
      cellText(row.produit, xProd, colW.produit, y, "left");
      cellText(row.format, xFmt, colW.format, y, "left");
      cellText(row.delay, xDel, colW.delay, y, "left");
      cellText(row.unitDisplay, xUnit, colW.unit, y, "right");
      cellText(row.qty, xQty, colW.qty, y, "right");
      cellText(row.totalDisplay, xTot, colW.total, y, "right");
      y += currentRowH;
    }

    var sum = rows.reduce(function (s, row) {
      return s + (Number(row.totalNum) || 0);
    }, 0);
    ensureTableSpace(rowH + 1);
    doc.setFont("helvetica", "bold");
    doc.setFillColor(235, 235, 235);
    doc.rect(margin, y, contentW, rowH, "FD");
    doc.rect(margin, y, contentW, rowH, "S");
    doc.line(xQty, y, xQty, y + rowH);
    doc.line(xTot, y, xTot, y + rowH);
    doc.setFontSize(9);
    doc.text(calcT('pdf_total', 'TOTAL HT'), xRef + 1.5, y + 5);
    cellText(formatMoneyEUR(sum), xTot, colW.total, y, "right");
    y += rowH;

    doc.line(margin, y, margin + contentW, y);
    return y + 4;
  }

  function buildAndSavePdf(shopName, logoDataUrl, data) {
    var rows = (data && data.rows) || [];
    var rowsEasyOrder = (data && data.rowsEasyOrder) || [];
    var jspdf = window.jspdf;
    var JsPDF = jspdf && typeof jspdf.jsPDF === "function" ? jspdf.jsPDF : null;
    if (!JsPDF && typeof window.jsPDF === "function") JsPDF = window.jsPDF;
    if (!JsPDF) {
      throw new Error(calcT('pdf_js_missing', 'La bibliothèque jsPDF est introuvable.'));
    }
    var doc = new JsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
    var pageH = doc.internal.pageSize.getHeight();
    var pageW = doc.internal.pageSize.getWidth();
    var margin = 15;
    var contentW = pageW - margin * 2;
    var y = margin;

    if (logoDataUrl) {
      try {
        var imgFmt = imageFormatFromDataUrl(logoDataUrl);
        doc.addImage(logoDataUrl, imgFmt, margin, y, 38, 12);
        y += 14;
      } catch (e) {
        /* ignore */
      }
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(calcT('pdf_simulation_title', 'Simulation de tarifs'), margin, y + 4);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    var dateStr = new Date().toLocaleDateString((window.__calculatorI18n && window.__calculatorI18n.locale) || document.documentElement.lang || 'fr-FR', {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
    doc.text(dateStr, pageW - margin - doc.getTextWidth(dateStr), y + 4);
    y += 12;

    if (shopName) {
      doc.setFontSize(10);
      doc.text(shopName, margin, y);
      y += 6;
    }

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(100, 100, 100);
    doc.text(calcT('pdf_disclaimer', 'Document de simulation — non contractuel.'), margin, y);
    doc.setTextColor(0, 0, 0);
    y += 8;

    var hasPlanche = rows.length > 0;
    var hasEasy = rowsEasyOrder.length > 0;
    if (hasPlanche) {
      y = drawInvoiceTable(doc, margin, contentW, y, rows, { sectionTitle: calcT('sheet_quote', 'Devis en planche') });
    }
    if (hasEasy) {
      if (hasPlanche) y += 3;
      y = drawInvoiceTable(doc, margin, contentW, y, rowsEasyOrder, { sectionTitle: calcT('easy_order_quote', 'Devis Easy order') });
    }

    drawFooterOnAllPages(doc, pageW, pageH, margin, contentW);

    doc.save(calcT('pdf_filename', 'simulation-tarifs.pdf'));
  }

  function handleDownloadClick(ev) {
    var el = ev.target;
    if (!el || typeof el.closest !== "function") return;

    var btn = el.closest("[is-download-quote-pdf]");
    if (!btn) return;

    /*
     * Delegate from document because Patch Calculator is lazy-mounted.
     * Binding only to sections present on DOMContentLoaded misses the
     * dynamically inserted calculator section and its PDF button.
     */
    var section = btn.closest("[data-imposition-quote-pdf]");
    if (!section) return;

    var data = collectInvoiceRows(section);
    if (!data.rows.length && !(data.rowsEasyOrder && data.rowsEasyOrder.length)) {
      toast(calcT('pdf_no_simulation', "Calculez d'abord une simulation pour générer le PDF."));
      return;
    }

    var logoUrl = section.getAttribute("data-pdf-logo-url") || "";
    var shopName = section.getAttribute("data-pdf-shop-name") || "";
    btn.disabled = true;

    loadImageDataUrl(logoUrl, function (dataUrl) {
      try {
        buildAndSavePdf(shopName, dataUrl, data);
      } catch (e) {
        toast(e && e.message ? e.message : String(e));
      } finally {
        btn.disabled = false;
      }
    });
  }

  onReady(function () {
    if (window.__impositionQuotePdfDelegatedBound) return;
    window.__impositionQuotePdfDelegatedBound = true;
    document.addEventListener("click", handleDownloadClick);
  });
})();